import { getPanelShadow } from "common/NewLook/tokens.ts";
import styled from "styled-components";
import Title from "common/Typography/Title";
import { VIRTUAL_CARDS_LIST_PADDING } from "@shared/common/constants";
import { OpenInNewIcon } from "common/Icons/Icons";
import Card from "common/Boxes/Card";
import {
  MOBILE_TRADE_CARD_HEIGHT,
  MOBILE_TRADE_CARD_WIDTH,
  TRADE_CARD_HEIGHT,
  TRADE_CARD_WIDTH,
} from "features/dashboard/common/constants";
import AntFireFilled from "@ant-design/icons/FireFilled";

export const SectionTitle = styled(Title).attrs({
  level: 2,
  type: "secondary",
})`
  font-weight: ${(p) => p.theme.typography.fontWeights.SEMI_BOLD};
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const StyledOpenInNewIcon = styled(OpenInNewIcon)`
  fill: ${(p) => p.theme.colors.secondaryGrey};
  width: 14px;
  height: auto;
  :hover {
    fill: ${(p) => p.theme.colors.primaryBlue};
  }
`;

export const EmptyWrapper = styled.div<{ $cardHeight: number }>`
  min-height: calc(
    ${(p) => p.$cardHeight}px + 2 * ${VIRTUAL_CARDS_LIST_PADDING}px
  );
`;
export const StyledCard = styled(Card)<{
  $isMobile: boolean;
  $isClosed: boolean;
  $fluid?: boolean;
}>`
  background: ${(p) => p.theme.colors.cardBgColor};
  height: ${(p) =>
    p.$isMobile ? `${MOBILE_TRADE_CARD_HEIGHT}px` : `${TRADE_CARD_HEIGHT}px`};
  width: ${(p) =>
    p.$isMobile ? `${MOBILE_TRADE_CARD_WIDTH}px` : `${TRADE_CARD_WIDTH}px`};
  display: flex;
  flex-direction: column;
  box-shadow: ${(p) =>
    p.theme.isNewLook
      ? getPanelShadow(p.theme)
      : p.theme.shadows.dashboardCard};
  cursor: pointer;
  padding: ${(p) => (p.$isMobile ? 12 : 16)}px;
  ${(p) =>
    p.$isClosed &&
    `
    opacity: 0;
    `};
  ${(p) =>
    p.$isClosed &&
    `
   border: 1px solid #F6392DBF;
   box-shadow: rgb(246 57 45) 0 0 9px;
   animation: fadeout 3s ease-in-out forwards;
`};
  ${(p) =>
    p.$fluid &&
    `
    width: 100%;
  `}
`;

export const FireFilled = styled(AntFireFilled)`
  color: ${(p) => p.theme.colors.red};
  margin: 0 4px;
`;

export const getMobileSectionTitleProps = (isNewLook: boolean) =>
  isNewLook
    ? ({ level: 3, $weight: 600 } as const)
    : ({ level: 4, type: "secondary" } as const);
